import { render, staticRenderFns } from "./BonusValidate.vue?vue&type=template&id=53b7d742"
import script from "./BonusValidate.vue?vue&type=script&lang=js"
export * from "./BonusValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports